<template>
  <div class="page-importexcel">
	   <Spin fix class="pg-sub-loading" v-if="imports">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">客服專區</div>
      <div class="breadcrumb-item">Excel入库</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <!--<FormItem>
          <DatePicker type="date" size="small" placeholder="起始日期" :options="options3" v-model="form.start_time"
                      value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker type="date" size="small" placeholder="結束日期" :options="options3" v-model="form.end_time"
                      value-format="yyyy-MM-dd" style='width: 100%;'></DatePicker>
        </FormItem>-->

        <Form inline class="pg-form-inline form-input-wrap">
          <!--<FormItem>
            <label class="input-label">用戶電話</label>
            <Input size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">快遞單號</label>
            <Input size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
          </FormItem>-->
          <FormItem>
            <div class="pg-btn-wrap">
              <!--<div class="pg-btn style1" @click="handleSearch">搜索</div>-->
	            <!--<div class="pg-btn style2" @click="handleExport">导出</div>-->
	            <!--<div class="pg-btn style2" @click="handleShowEidt">导入</div>-->
	            <div>
					      <Upload
						      action=""
						      accept=".xls,.xlsx"
						      :before-upload="handleUpload">
					          <Button icon="ios-cloud-upload-outline">导入</Button>
					      </Upload>
					      <div style="display: flex;align-items: center;" v-if="file !== null">
						      <span style="margin-right: 20px;">文件名: {{ file.name }}</span>
						      <Button icon="ios-cloud-upload-outline" class="pg-btn style2" type="text" @click="upload"
						              :loading="loadingStatus">{{ loadingStatus ? '上傳中' : '批量入庫' }}</Button>
					      </div>
					  </div>
            </div>
          </FormItem>
        </Form>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <Table size="small"
             ref="selection"
             border
             no-data-text="暫無數據"
             :columns="table.column"
             :data="table.data">
        <template slot-scope="{ row }" slot="action">
          <div class="pg-btn-wrap">
            <!--<div class="pg-btn style2" @click="handleShowEidt(row)">修改</div>-->
            <div class="pg-btn style1" @click="handleDel(row.id)">刪除</div>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total mg-r10">總共{{ totalCount }}條記錄</div>
          </Col>
	        <!--<Col span="13" class="pagger-right">
						<div>
							<div class="pagger-sizer">
								<span>每頁</span>
								<Select v-model="curPageSize" size="small" placeholder="數量"
												@on-change="handlePageSizeChange">
									<Option :value="10">10</Option>
									<Option :value="20">20</Option>
									<Option :value="30">30</Option>
									<Option :value="40">40</Option>
									<Option :value="50">50</Option>
								</Select>
							</div>

							<div class="pagger-elevator">
								<span>跳轉</span>
								<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
											 @on-enter="handlePageEnter"/>
							</div>

							<Page size="small"
										:current="pageIndex"
										:page-size="curPageSize"
										:total="totalCount"
										@on-change="handlePageChange">
							</Page>
						</div>
					</Col>-->
        </Row>
      </div>
    </div>

    <Modal v-model="showedit"
           title="新增"
           width="400"
           :footer-hide="true">
      <div class="modal-cont">
        <Form>
          <FormItem>
            <label class="input-label">手机号码</label>
            <Input clearable v-model="editForm.phone"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">快遞單號</label>
            <Input clearable v-model="editForm.odd_number"></Input>
          </FormItem>
          <FormItem>
            <label class="input-label">商品描述</label>
            <Input clearable v-model="editForm.order_remark"></Input>
          </FormItem>

          <FormItem>
            <div class="pg-btn-wrap">
              <div class="pg-btn style1" style="width:100%;" @click="handleEidt">確定</div>
            </div>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios';
import Store from '../../../assets/js/store.js'
import {read, utils} from "xlsx";

export default {
	data() {
		return {
			pageIndex: 1,   //页码
			curPageSize: 10,    //一页数量
			totalCount: 0, //总条数
			pageInput: '',  //输入的页码
			form: {
				start_time: '',
				end_time: '',
				phone: '',
				odd_numbers: '',
				// order_number: '',
			},
			editForm: {
				phone: '',
				odd_number: '',
				order_remark: '',
			},
			isSubmiting: false,
			options3: {
				disabledDate(date) {
					return date && date.valueOf() > Date.now();
				}
			},
			showedit: false,
			table: {
				/**
				 * '*單號':'odd_numbers',
				 '*重量(kg)':'weight',
				 '*會員手機':'phone',
				 '*門店標識':'store_type',
				 '門店名稱':'store_name',
				 '門店地址':'store_addr',
				 '商品類型':'order_type',
				 '商品名稱':'order_name',
				 '商品介紹':'order_desc',
				 '商品標簽':'order_tag',
				 '長':'long',
				 '寬':'wide',
				 '高':'height',
				 */
				column: [
					// {
					// 	title: '操作',
					// 	slot: 'action',
					// 	align: 'center',
					// 	minWidth: 230
					// },
					{
						title: '快遞單號',
						key: 'odd_numbers',
						align: 'center',
						sortable: true,
						minWidth: 150
					},
					{
						title: '重量(kg)',
						key: 'weight',
						align: 'center',
						sortable: true,
						width: 80
					},
					{
						title: '會員手機',
						key: 'phone',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '門店標識',
						key: 'store_type',
						align: 'center',
						sortable: true,
						minWidth: 130
					},
					{
						title: '門店名稱',
						key: 'store_name',
						align: 'center',
						minWidth: 160
					}, {
						title: '門店地址',
						key: 'store_addr',
						align: 'center',
						minWidth: 250
					}, {
						title: '商品類型',
						key: 'order_type',
						align: 'center',
						minWidth: 160
					}, {
						title: '商品名稱',
						key: 'order_name',
						align: 'center',
						minWidth: 160
					}, {
						title: '商品介紹',
						key: 'order_desc',
						align: 'center',
						minWidth: 160
					}, {
						title: '商品標簽',
						key: 'order_tag',
						align: 'center',
						minWidth: 160
					}, {
						title: '長',
						key: 'long',
						align: 'center',
						minWidth: 160
					}, {
						title: '寬',
						key: 'wide',
						align: 'center',
						minWidth: 160
					}, {
						title: '高',
						key: 'height',
						align: 'center',
						minWidth: 160
					},
				
				],
				data: []
			},
			file: null,
			loadingStatus: false,
			imports: false
		};
	},
	created() {
		// this.getList()
	},
	methods: {
		readFile(file) {
			return new Promise(resolve => {
				let reader = new FileReader();
				reader.readAsBinaryString(file);
				reader.onload = ev => {
					resolve(ev.target.result)
				}
			})
		},
		handleUpload(file) {
			console.log(file)
			
			if (!file) return
			this.imports = true
			
			const changeCnToEn = {
				'*單號': 'odd_numbers',
				'*重量(kg)': 'weight',
				'*會員手機': 'phone',
				'*門店標識': 'store_type',
				'門店名稱': 'store_name',
				'門店地址': 'store_addr',
				'商品類型': 'order_type',
				'商品名稱': 'order_name',
				'商品介紹': 'order_desc',
				'商品標簽': 'order_tag',
				'長': 'long',
				'寬': 'wide',
				'高': 'height',
				
			}
			this.readFile(file).then(data => {
				this.table.data = [];
				const workbook = read(data, {type: 'binary'});
				const firstSheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[firstSheetName];
				const results = utils.sheet_to_json(worksheet);
				console.log(results);
				if (!results.length) {
					this.imports = false
					return this.$message.warning('導入内容爲空或不匹配，請核對表頭和内容')
				}
				let res = results.filter(item => {
					return item['*單號']
				})
				console.log(res)
				
				if (!res.length) {
					this.imports = false
					return this.$message.warning('導入内容爲空或不匹配，請核對表頭和内容')
				}
				
				const arr = []
				res.forEach(item => {
					const info = {}
					//  console.log(Object.keys(item))
					Object.keys(item).forEach(key => {
						info[changeCnToEn[key]] = item[key]
					})
					// console.log(userInfo)
					arr.push(info)
				})
				console.log(arr)
				const flatList = new Set(arr.map(item => item.odd_numbers)).size;
				if (arr.length > flatList) {
					this.imports = false
					return this.$message.warning('導入数据单号重复，请检查')
				}
				
				this.table.data = arr.map(item => {
					const store_type = item.store_type
					item.store_type = store_type.split('-')[0]
					item.store_name = store_type.split('-')[1]
					return item
				})
				console.log(this.table.data)
				this.totalCount = arr.length
				this.file = file;
				this.imports = false
			})
			
			return false;
		},
		upload() {
			this.loadingStatus = true;
			
			this.$Modal.confirm({
				title: '提示',
				content: '<p>是否要提交數據</p>',
				onOk: () => {
					const data = this.table.data;
					this.$Rq.requestAuth({
						url: this.$Api.expressinterception_import,
						method: 'post',
						data
					}).then(res => {
						if (res.code === 0) {
							this.file = null;
							this.table.data = []
							this.totalCount = 0
							this.loadingStatus = false;
							this.$Message.success(res.msg)
						} else {
							this.loadingStatus = false;
							this.$Message.error(res.msg)
						}
					}).catch(err => {
						this.loadingStatus = false;
					})
					
				},
				onCancel: () => {
					this.loadingStatus = false;
					this.$Message.info('取消提交');
				}
			});
			
		},
		// 刪除
		handleDel(id) {
			let _this = this
			this.$Modal.confirm({
				title: '警告',
				content: '<p>是否要删除</p>',
				onOk: () => {
					_this.$Rq.requestAuth({
						url: this.$Api.expressinterception_del,
						method: 'post',
						data: {
							id
						}
					}).then((res) => {
						_this.$Message.info(res.msg)
						_this.getList();
					}).catch((err) => {
						_this.$Message.error('服務端異常，請重試')
					});
				},
				onCancel: () => {
				
				}
			});
			
		},
		// 修改
		handleShowEidt() {
			this.editForm.phone = ''
			this.editForm.odd_number = ''
			this.editForm.order_remark = ''
			this.showedit = true
		},
		// 確認 修改
		handleEidt() {
			let form = this.editForm
			this.$Rq.requestAuth({
				url: this.$Api.expressinterception_add,
				method: 'post',
				data: {
					odd_nuumbers: form.odd_number,
					phone: form.phone
				}
			}).then((res) => {
				this.$Message.info(res.msg)
				this.showedit = false;
				this.getList();
			}).catch((err) => {
				this.$Message.error('服務端異常，請重試')
			});
			
		},
		// 导出
		handleExport() {
			let token = localStorage.getItem('jyb_token');
			let form = this.form;
			let params = {
				'Authorization': token,
				start_time: this.formatDate(form.start_time),
				end_time: this.formatDate(form.end_time),
				phone: form.phone,
				odd_numbers: form.odd_numbers,
				order_number: form.order_number,
			};
			let formatParams = this.$Utils.formateObjToParamStr(params);
			if (new Set(Object.values(this.form)).size === 1) {
				this.$Utils.showTipInfo("請輸入搜索條件");
				return false;
			}
			let a = document.createElement('a')
			a.href = `${this.$Api.exportDailyCountStoreNew}?${formatParams}`
			a.click()
		},
		// 获取列表
		getList() {
			let form = this.form;
			form.start_time = this.formatDate(form.start_time)
			form.end_time = this.formatDate(form.end_time)
			this.isSubmiting = true;
			this.$Rq.requestAuth({
				url: this.$Api.expressinterception_list,
				method: 'get',
				data: {
					...form,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize
				}
			}).then((res) => {
				console.log(res)
				this.isSubmiting = false;
				if (res.code == 0) {
					this.table.data = res.data.data
					this.totalCount = res.data.count || 0;
				}
			}).catch((err) => {
				this.isSubmiting = false;
			});
		},
		
		formatDate(datetime) {
			if (!datetime) return '';
			let dateTime = new Date(datetime);
			let year = dateTime.getFullYear();
			let month = dateTime.getMonth() + 1;
			let date = dateTime.getDate();
			let hour = dateTime.getHours();
			let minute = dateTime.getMinutes();
			let second = dateTime.getSeconds();
			let milliseconds = dateTime.getMilliseconds();
			return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
		},
		formatNum(num) {
			return num < 10 ? '0' + num : num;
		},
		handleSearch() {
			this.pageIndex = 1;
			this.getList();
		},
		handlePageSizeChange(value) {
			this.pageIndex = 1;
			this.getList();
		},
		handlePageInput() {
			let value = ('' + this.pageInput).replace(/\D/g, '');
			let pageCount = Math.ceil(this.totalCount / this.curPageSize);
			if (value > pageCount) {
				value = pageCount;
			}
			this.pageInput = value;
		},
		handlePageEnter() {
			if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
			if (this.pageInput == 0) {
				this.pageInput = 1;
			}
			this.pageInput = parseInt(this.pageInput);
			this.pageIndex = this.pageInput;
			this.getList();
		},
		handlePageChange(value) {
			this.pageIndex = value;
			this.getList();
		}
	}
};
</script>
<style>
.card-block .ivu-table-cell {
	line-height: 1.5 !important;
}
</style>
<style lang="scss" scoped>
@import "importexcel.scss";
</style>
